import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Label, Input, Button, Modal, ModalFooter, ModalHeader, ModalBody } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Moment from 'react-moment';
import 'moment-timezone';
import { getApiToken } from '../msalInstance';

function EditDefaults(props) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    function closeModal() {
        setData(null);
        props.setModalItemID(null);
        props.setShowModal(false);
    }

    async function HandleSubmit(e) {
        e.preventDefault();
        
        const accessToken = await getApiToken();

        const submitOptions = {
            method: 'put',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
            body: JSON.stringify({
                internalValue: e.target.internal_value.value,
                externalValue: e.target.external_value.value,
                notes: e.target.notes.value,
                modifiedBy: props.username,
                sortorder: e.target.sortOrder.value,
                name: e.target.displayName.value
            })
        };

        fetch(`/api/DefaultItem/${props.itemID}`, submitOptions)
            .then((response) => {
                return response;
            })
            .catch((err) => {
                setError(err.message);
            })
            .finally(() => {
                setData(null);
                props.setModalItemID(null);
                closeModal();
                props.getDefaults();
            });

    }

    useEffect(() => {
        if (props.itemID && !data) {
            fetch(`/api/DefaultItem/${props.itemID}`)
                .then((response) => {
                    return response.json();
                })
                .then((actualData) => {
                    setData(actualData);
                    setError(null);
                })
                .catch((err) => {
                    setError(err.message);
                    setData(null);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    });

    return (
        <Modal isOpen={props.showModal}>
            {loading && <div>Loading...</div>}
            {error && (
                <div>{`There is a problem fetching the post data - ${error}`}</div>
            )}
            {data &&
                (
                    <>
                        <ModalHeader>
                            {data.name}
                        </ModalHeader>
                        <ModalBody>
                            <Container>
                                <Form onSubmit={(evt) => HandleSubmit(evt)}>
                                    <Row className="mb-2">
                                        <Col xs="4">
                                            <Label htmlFor="displayName">Display Name</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input required type="text" name="displayName" defaultValue={data.name} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs="4">
                                            <Label for="internalValue">Internal Value</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input step=".01" required type="number" name="internal_value" defaultValue={data.internalValue} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs="4">
                                            <Label for="externalValue">External Value</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input step=".01" required type="number" name="external_value" defaultValue={data.externalValue} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs="4">
                                            <Label for="notes">Notes</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input type="textarea" name="notes" defaultValue={data.notes} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="4">
                                            <Label for="sortorder">Sort Order</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input step="1" type="number" required name="sortOrder" defaultValue={data.sortOrder} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12">
                                            <div className="modifiedByText">Last modified by {data.modifiedBy} on <Moment format="MM/DD/YY hh:mm a" local>{data.modified}</Moment></div>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <ModalFooter>
                                            <Button onClick={closeModal}>
                                                Cancel
                                            </Button>
                                            <Button variant="primary" type="Submit">
                                                Submit
                                            </Button>
                                        </ModalFooter>
                                    </Row>
                                </Form>
                            </Container>
                        </ModalBody>
                    </>
                )}

        </Modal>
    )
}

export default EditDefaults;
